window.updateRegiosPricing = async function (event, containerSelector) {
  const container = document.querySelector(containerSelector);
  const { product, selectedProduct } = event.detail || {};

  if (!container || !product || !selectedProduct) return;

  if (product.tags?.includes("excludedFromPromotions")) return;

  const variant = product.variants.find(
    (v) => Number(v.id) === Number(selectedProduct)
  );
  const priceBlock = container.querySelector(".price-block");
  if (!priceBlock) return;

  const salePriceEl = priceBlock.querySelector(".price-item--sale");
  const strikePriceEl = priceBlock.querySelector(
    ".price__sale s.price-item--regular"
  );

  try {
    const api = window.RegiosDOPP?.api?.v0;
    if (!api?.calculateDiscountedPrices) return;

    const { salePrice, regularPrice } = await api.calculateDiscountedPrices({
      productId: Number(product.productId || product.id),
      variantId: selectedProduct,
      regularPriceInCents: variant?.priceInCents ?? Number(product.price),
    });

    if (
      salePrice?.formatted &&
      regularPrice?.formatted &&
      salePrice.amount < regularPrice.amount
    ) {
      if (salePriceEl) {
        salePriceEl.textContent = salePrice.formatted;
        priceBlock.classList.add("regios-dopp-generic-price-item--sale");
      }
      if (strikePriceEl) {
        strikePriceEl.textContent = regularPrice.formatted;
      }
    } else {
      if (salePriceEl) salePriceEl.textContent = regularPrice.formatted;
      if (strikePriceEl) strikePriceEl.textContent = "";
    }
  } catch (e) {
    console.warn("Regios price update failed:", e);
  }

  if (typeof window.watchAndFormatStrikethroughPrices === "function") {
    document.addEventListener('priceFormatted:regios', () => {
      const priceContainers = document.querySelectorAll('.price__container');
      priceContainers.forEach(priceContainer =>  priceContainer.style.visibility = 'visible');
    });
    window.watchAndFormatStrikethroughPrices();
  }
};
